( function( global, $ ) {
    "use strict";

    var DEADLINE_DATE = 2;
    var DEADLINE_BEFORE_DATE = 3;

    var _events = {
        onChangeDeadline: function() {
            $(this).trigger('refresh');
        },

        onRefreshDeadline: function() {
            var $deadlineInput = $(this),
                $formEntry = $deadlineInput.closest('[data-form-entry="deposit"]'),
                $dateField = $formEntry.find('[data-form-field="date"]'),
                $dateInput = $formEntry.find('[data-form-control="date"]'),
                deadline = parseInt($deadlineInput.val());

            $dateField.addClass('hidden');
            $dateInput.prop('required', false);

            if (-1 !== [DEADLINE_DATE, DEADLINE_BEFORE_DATE].indexOf(deadline)) {
                $dateField.removeClass('hidden');
                $dateInput.prop('required', true);
            }
        }
    };

    var $body = $('body');

    $body.on('app.init', function(ev) {
        var $container = $(ev.container),
            $formEntries = $container.find('form [data-form-entry="deposit"]'),
            $deadlineInputs = $formEntries.find('[data-form-control="deadline"]');

        $deadlineInputs
            .on('change', _events.onChangeDeadline)
            .on('refresh', _events.onRefreshDeadline)
            .trigger('refresh');
    });

}( window.groots, jQuery ));
